import React from 'react';

import { DefaultView, EditView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { PersonProfileEditHintConfigEditView } from './views/PersonProfileEditHintConfigEditView';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PersonProfileEditHintConfigDefaultView } from './views/PersonProfileEditHintConfigDefaultView';

type PersonProfileEditHintConfig = BlockWithViews<
  DefaultView<{ value: string }> & EditView<any> & { noContentMessage: string }
>;

/* currently not used as feature needs further discussion,
for example about support email address injection into custom text.
 * reuse when feature set was clarified. */
function PersonProfileEditHintConfig({ views, activeView }: PersonProfileEditHintConfig) {
  const { t } = useSonTranslation('PersonProfileEditHintConfig');
  const { uuid, elementType } = useBlockContext();

  const headline = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const buttons = createButtonObject(
    Views.EDIT,
    Icons.EDIT_PENCIL,
    `PersonProfileEditHintConfig:edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <PersonProfileEditHintConfigEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <PersonProfileEditHintConfigDefaultView {...views.default} noContentMessage={t('noContent')} />
    </BlockInteractions>
  );
}

export const PersonProfileEditHintConfigBlock = asFetchableBlock(
  PersonProfileEditHintConfig,
  BlockType.personProfileEditHintConfig,
);
